import React from 'react';
import ReactDOM from 'react-dom/client';
// import { Theme } from '@radix-ui/themes';
import '@radix-ui/themes/styles.css';
import '@/icon/css/fontello.css';
import '@/index.css';
import App from '@/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <Theme> */}
    <App />
    {/* </Theme> */}
  </React.StrictMode>,
);
